// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1L_2x","imageUploader":"EGiftCard_imageUploader__pMeOi"};